import "./bulkTestOrderListScreen.scss";
import ButtonComponent from "../../shared/components/core/button/ButtonComponent";
import React, {useCallback, useEffect, useState} from "react";
import AddIcon from '@mui/icons-material/Add';
import DrawerComponent from "../../shared/components/drawer/drawerComponent";
import BulkTestOrderListTableComponent from "./bulk-test-order-list-table/bulkTestOrderListTableComponent";
import ImportBulkTestOrderComponent from "./import-bulk-test-order/importBulkTestOrderComponent";
import {useDispatch, useSelector} from "react-redux";
import {setCurrentNavParams, setSideMenuView} from "../../store/actions/header.action";
import {useNavigate} from "react-router-dom";
import CommonService from "../../shared/services/common.service";
import _ from "lodash";
import {IRootReducerState} from "../../store/reducers";
import SearchComponent from "../../shared/components/search/SearchComponent";
import commonService from "../../shared/services/common.service";
import DownloadIcon from "@mui/icons-material/Download";

interface BulkTestOrderListScreenComponentProps {

}

const FiltersInitialState: any = {
    search: '',
}

const BulkTestOrderListScreen = (props: BulkTestOrderListScreenComponentProps) => {
    // const [isTemplateDrawerOpen, setIsTemplateDrawerOpen] = React.useState<boolean>(false);
    const [isImportTestOrderDrawerOpen, setIsImportTestOrderDrawerOpen] = React.useState<boolean>(false);
    const [filterData, setFilterData] = useState<any>(_.cloneDeep(FiltersInitialState));
    const {queryParamData} = useSelector((state: IRootReducerState) => state.stateManagement);
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);
    const [istemplateDownloading, setIsTemplateDownloading] = useState<boolean>(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();


    useEffect(() => {
        dispatch(setCurrentNavParams("Bulk Test Order", "Test Order"));
        dispatch(setSideMenuView('compact'));
    }, [dispatch, navigate]);

    const handleSearch = useCallback((value: string) => {
        setFilterData((prevState: any) => ({
            ...prevState,
            search: value
        }));
    }, []);

    const downloadTemplate = useCallback(() => {
        setIsTemplateDownloading(true);
        CommonService._staticData.downloadBulkTemplate({})
            .then((res: any) => {
                setIsTemplateDownloading(false);
                commonService.downloadFile(res?.data?.url, 'bulk-test-order-template.xlsx','xlsx')
            })
            .catch(() => {
                setIsTemplateDownloading(false)
                commonService._alert.showToast('Something went wrong while downloading template');
            })
    }, []);

    useEffect(() => {
        if (queryParamData) {
            const data: any = {
                search: queryParamData.search || '',
            };
            setFilterData((prevState: any) => ({
                ...prevState, ...data
            }));
        }
    }, [queryParamData]);

    return (
        <div className={'bulk-test-order-list-screen-component screen'}>
            <div className={"screen-content-wrapper"}>
                <div className="page-data-wrapper">
                    <div className="page-options">
                        <div className="page-search">
                            <SearchComponent
                                label={"Search Bulk Order"}
                                id="search_input"
                                placeholder={""}
                                value={filterData.search}
                                onChange={handleSearch}
                            />
                        </div>

                        <div className="page-extra-options">
                            <ButtonComponent
                                type="button"
                                id="template_btn"
                                color={"secondary"}
                                variant={"outlined"}
                                isLoading={istemplateDownloading}
                                fullWidth={false}
                                handleClick={() => {
                                    downloadTemplate();
                                }}
                                startIcon={<DownloadIcon/>}
                            >
                                Download Template
                            </ButtonComponent>
                            {
                                commonService.checkAccess('TestOrder', "testOrderImportBulk", currentUser?.userAccessModules) &&
                                <ButtonComponent
                                    type="button"
                                    color={"primary"}
                                    variant={"contained"}
                                    id="add_bulk_test_order_button"
                                    handleClick={() => {
                                        setIsImportTestOrderDrawerOpen(true)
                                    }}
                                    startIcon={<AddIcon/>}
                                >
                                    Import File
                                </ButtonComponent>
                            }
                        </div>
                    </div>

                    <>
                        <BulkTestOrderListTableComponent filterData={filterData}/>
                    </>
                </div>
            </div>

            {/*<DrawerComponent open={isTemplateDrawerOpen}*/}
            {/*                 className={"drawer-wrapper"}*/}
            {/*                 closeOnBackDropClick={true}*/}
            {/*                 closeOnEsc={true}*/}
            {/*                 title={"Import Bulk Test Order"}*/}
            {/*                 onClose={() => setIsTemplateDrawerOpen(false)}*/}
            {/*>*/}
            {/*    <>*/}
            {/*        <BulkTestOrderTemplateDownloadComponent onTemplateDrawerClose={() => {*/}
            {/*            setIsTemplateDrawerOpen(false)*/}
            {/*        }}/>*/}
            {/*    </>*/}
            {/*</DrawerComponent>*/}

            <DrawerComponent open={isImportTestOrderDrawerOpen}
                             className={"drawer-wrapper"}
                             closeOnBackDropClick={true}
                             closeOnEsc={true}
                             title={"Import Bulk Test Order File"}
                             onClose={() => setIsImportTestOrderDrawerOpen(false)}
            >
                <>
                    <ImportBulkTestOrderComponent/>
                </>
            </DrawerComponent>

        </div>
    );

};

export default BulkTestOrderListScreen;
